import React from 'react';

import { VerticalImageInputRadioList } from '../../components/common/organism/InputRadioList';

const FrameListView = ({
  frameList,
  selectedFrame,
  inspectingLock = false,
  onSelectFrame,
}) => {
  if (frameList === null) return null;
  return (
    <VerticalImageInputRadioList
      radioData={frameList.map((frame) => ({
        id: frame.id,
        src: frame.lookAndFeelImage.storageUri,
        checked: selectedFrame === frame.alias,
        onChange: () =>
          onSelectFrame({
            selectedFrame: frame.alias,
            previewImage: frame.previewImage.storageUri,
            previewFrameName: frame.meta.name,
          }),
        disabled: inspectingLock,
      }))}
    />
  );
};

export default FrameListView;
